import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Flame } from "lucide-react";
import { HOURS, DAYS, HEATMAP_COLORS, heatColor } from "./analyticsUtils";

export function HeatmapCard({ heatmap }) {
  const hm = heatmap || {};
  const maxHeat = Math.max(...(hm.cells || []).map(c => c.orders), 1);

  return (
    <Card className="bg-white shadow-sm" data-testid="heatmap-card">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2 text-gray-800">
            <Flame className="w-5 h-5 text-orange-500" />
            Mapa de Calor - Produção
          </CardTitle>
          {hm.peak && (
            <Badge variant="outline" className="text-xs bg-orange-50 text-orange-700 border-orange-200">
              Pico: {hm.peak.day_name} {hm.peak.hour}h ({hm.peak.orders} pedidos)
            </Badge>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <div className="min-w-[600px]">
            <div className="flex ml-12 mb-2">
              {HOURS.filter(h => h % 2 === 0).map(h => (
                <span key={h} className="text-xs text-gray-500 font-medium" style={{ width: `${100 / 12}%`, textAlign: "center" }}>{h}h</span>
              ))}
            </div>
            {DAYS.map((day, di) => (
              <div key={di} className="flex items-center gap-2 mb-1">
                <span className="text-xs text-gray-600 font-medium w-10 text-right">{day}</span>
                <div className="flex-1 flex gap-0.5">
                  {HOURS.map(h => {
                    const cell = (hm.cells || []).find(c => c.day === di && c.hour === h);
                    const val = cell?.orders || 0;
                    return (
                      <div
                        key={h}
                        className="flex-1 h-7 rounded cursor-pointer transition-all hover:scale-105 hover:shadow-md"
                        style={{ background: heatColor(val, maxHeat), minWidth: 18 }}
                        title={`${day} ${h}h: ${val} pedidos${cell?.avg_prep_min ? ` (preparo: ${cell.avg_prep_min}min)` : ""}`}
                      />
                    );
                  })}
                </div>
              </div>
            ))}
            <div className="flex items-center gap-2 mt-4 ml-12">
              <span className="text-xs text-gray-500">Menos pedidos</span>
              <div className="flex gap-0.5">
                {HEATMAP_COLORS.map((c, i) => (<div key={i} className="w-6 h-4 rounded" style={{ background: c }} />))}
              </div>
              <span className="text-xs text-gray-500">Mais pedidos</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
